const MY_COURSES = 'my-courses'
const VIEW_ALL = 'view-all'
const LIBRARY = 'library'

export enum MyCoursesTabs {
  status = 'status',
  categories = 'categories',
  learningPaths = 'learningPaths',
}

export type CourseStatePath =
  | 'pending'
  | 'in_progress'
  | 'finished'
  | 'upcoming'
  | 'closed'

export const paths = {
  home: {
    root: '/',
    folder: {
      details: (id: string | number, name: string) =>
        `/${VIEW_ALL}/catalogue/folder/${id}/${name}`,
    },
    advanceCourses: {
      details: (state: CourseStatePath) => `/${VIEW_ALL}/advance/${state}`,
    },
    premieres: `/${VIEW_ALL}/catalogue/premieres`,
    learningPaths: '/learning-paths',
  },
  myCourses: {
    root: `/${MY_COURSES}`,
    folder: {
      details: (id: string | number, name: string, origin: string) =>
        `/${VIEW_ALL}/${MY_COURSES}/folder/${id}/${name}/${origin}`,
      premieres: `${MY_COURSES}/folder/premieres`,
    },
    advanceCourses: {
      details: (state: CourseStatePath) =>
        `/${VIEW_ALL}/${MY_COURSES}/${state}`,
    },
    premieres: `/${VIEW_ALL}/${MY_COURSES}/premieres`,
    learningPaths: `/${MY_COURSES}/${MyCoursesTabs.learningPaths}`,
  },
  library: {
    root: `/${LIBRARY}`,
    folder: {
      details: (id: string | number, name: string) =>
        `/${VIEW_ALL}/${LIBRARY}/folder/${id}/${name}`,
    },
    populars: `/${VIEW_ALL}/${LIBRARY}/popular`,
    premieres: `/${VIEW_ALL}/${LIBRARY}/premieres`,
  },
  learningPath: {
    details: (id: string | number) => `/learning-path/${id}`,
  },
}
